module.exports = __webpack_public_path__ + "static/img/image@2x.678ba72.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/activity/ktb_min/image@2x.png
// module id = S+qc
// module chunks = 69